import React, {Component} from 'react';
import Api from "../../utils/Api";
import PropTypes from "prop-types";
import Timeformat from "../../utils/Timeformat";
import Job from "../../utils/Job";
import LoadingSplash from "../../globalComponents/LoadingSplash";

class MachineHistory extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machine: PropTypes.object.isRequired,
        page: PropTypes.number,
        maxRows: PropTypes.number,
    };

    static defaultProps = {
        page: 0,
        maxRows: 50
    };

    constructor(props) {

        super(props);

        this.state = {
            history: null,
        };

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.page = props.page;

        this.getHistory = this.getHistory.bind(this);
        this.getHistory();

        this.updateHistoryJob = new Job(this.getHistory, 30000);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.page !== this.page) {
            this.page = nextProps.page;
            this.getHistory();
        }

    }

    componentWillUnmount() {

        this.updateHistoryJob.stop();

    }

    getHistory() {

        if (this.state.history !== null) {
            this.setState({
                history: null
            });
        }

        const params = {
            machineId: this.props.machine.machine_id,
            companyId: this.props.baseData.companies.currentCompany.id,
            rows: this.props.maxRows,
            offset: this.props.maxRows * this.page
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    history: res
                });
            }
        }.bind(this);

        this.api.request('GetMachineStateHistory', params, callback, null);

    }

    getRows() {

        if (!this.state.history) return null;

        const timezone = this.props.baseData.companies.currentCompany.timezone;

        const jsonToLst = (json, key) => {
            json = JSON.parse(json);

            let out = [];

            for (let ix in json) {
                out.push(<div key={key + ix}>{this.translate(ix)}: {json[ix]}</div>);
            }

            return out;
        };

        return this.state.history.map((entry) => {
            let key = entry.timestamp + ':' + entry.action + ':' + entry.id_log;
            let dateCreated = (entry.timestamp) ? Timeformat.fromUnix(entry.timestamp).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

            return (
                <tr key={key}>
                    <td className="text-left">{dateCreated}</td>
                    <td className="text-left ">{this.translate(entry.action)}</td>
                    <td className="text-left diffresponsive">{jsonToLst(entry.details, key)}</td>
                </tr>
            )
        });

    }

    render() {

        if (!this.state.history) {
            return (
                <div style={{paddingTop: 50}}>
                    <LoadingSplash color={'#0e3043'}/>
                </div>
            );
        }

        const rows = this.getRows();

        return (
            <div className="bottomcontainer tablecontainer">
                {/*<!-- modified Bootstrap tables  -->*/}
                <table className="table">
                    <thead>
                        <tr>
                            <th>{this.translate('time')}</th>
                            <th>{this.translate('type')}</th>
                            <th className="diffresponsive">{this.translate('description')}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {rows}
                    </tbody>
                </table>
                {/*<!-- / modified Bootstrap tables  -->*/}
            </div>
        );

    }

}

export default MachineHistory;
